import { useTranslation } from 'react-i18next';
import { brandAssets } from '@/mocks/brand';

interface BrandLoaderProps {
  size?: number;
  fullScreen?: boolean;
}

export default function BrandLoader({ size = 120, fullScreen = false }: BrandLoaderProps) {
  const { t } = useTranslation();

  const loader = (
    <div role="status" aria-label={t('loaderLabel')} className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <span className="absolute inset-0 rounded-full border-2 border-transparent border-t-accent-400 border-r-primary-500 animate-spin" />
      <span className="absolute inset-[10%] rounded-full border-2 border-transparent border-b-secondary-400 border-l-accent-500 charvys-spin-reverse" />
      <span className="absolute inset-[20%] rounded-full bg-primary-500/20 blur-xl" />
      <img src={brandAssets.icon} alt="" className="relative w-[58%] h-[58%] object-contain charvys-pulse" />
    </div>
  );

  if (!fullScreen) return loader;

  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-background-950">{loader}</div>;
}